import Link from "next/link";
import { FC } from "react";

import { BankAccount } from "@/apis/clients";
import { AccountsListCard } from "@/components/organisms/accounts/AccountsListCard";

interface Props {
  bankAccount: BankAccount;
}

export const BankAccountInfo: FC<Props> = ({ bankAccount }) => {
  const bankAccountInfo = () => {
    return <p className="whitespace-pre-wrap">{bankAccount.bank_name ?? ""}</p>;
  };

  const setDtLink = (text: string, link: string) => {
    return (
      <>
        {text}
        <Link
          href={link}
          className="inline-block ml-2 font-normal text-primary-dark hover:underline">
          
            変更
          
        </Link>
      </>
    );
  };

  const Lists = [
    {
      dt: setDtLink("銀行振込先", "/accounts/edit/bank-account"),
      dd: bankAccountInfo(),
    },
  ];

  return <AccountsListCard title="振込先情報設定" list={Lists} />;
};
